export type Shortcoming = {
  id: string;
  title: string;
};
